import { Component } from '@angular/core'
import { appConfig } from '../../../../brands/_current/config/app-config'

@Component({
  selector: 'app-feedback-failure-svg-icon',
  templateUrl: './feedback-failure-svg-icon.component.html',
})
export class FeedbackFailureSvgIconComponent {
  public clientName = appConfig.core.clientName?.toLowerCase()
}
